import CommonEdit from "@/components/common/Edit";
import { useEffect, useState } from "react";
import UsersForm from "./UsersForm";
import axiosInstance from "@/utils/axiosInstance";
import { User } from "@/interface/entityInterface";

const UserEdit = ({ id }: { id: number }) => {
  const [formProp, setFormProp] = useState({
    firstname: "",
    lastname: "",
    email: "",
    user_role: "Owner",
  });

  useEffect(() => {
    if (!id) return;
    const getUser = async () => {
      const { data } = await axiosInstance.get<User>(`/users/${id}`);
      const { email, firstname, lastname, user_role } = data;
      setFormProp({
        firstname: firstname || "",
        lastname: lastname || "",
        user_role: user_role || "",
        email: email || "",
      });
    };

    getUser();
  }, [id]);

  return (
    <CommonEdit title="Edit" id={id} resource="users" data={formProp}>
      <UsersForm
        mode="edit"
        formProp={formProp}
        setFormProp={setFormProp}
        userRoles={[
          { label: "Owner", value: "owner" },
          { label: "Operator", value: "operator" },
        ]}
      />
    </CommonEdit>
  );
};

export default UserEdit;
